// Helpers puros de la búsqueda de la sección "Base de datos" (DBSearch).
// Extraídos de DBSearch.tsx para hacerlos testeables sin arrastrar antd/react-router.
// Búsqueda insensible a mayúsculas y a diacríticos (acentos, ñ, diéresis...).

export const normalizeSearchTerm = (term: string): string =>
  term.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '')

export const isMatch = (optionValue: string, input: string): boolean =>
  normalizeSearchTerm(optionValue).includes(normalizeSearchTerm(input))

export type DbSearchIndicator = {
  long_title: string
  slug?: string
}

// Búsqueda exacta por long_title (el valor del <Option> es exactamente se.long_title),
// devuelve el indicador para poder navegar a su slug.
export const findIndicatorByTitle = (
  indicators: DbSearchIndicator[],
  longTitle: string,
): DbSearchIndicator | undefined => indicators.find(obj => obj.long_title === longTitle)